import styled from "styled-components";
import { color } from "styled-system";

export const MultiWeekPlannerMainContainer = styled("section")`
  display: flex;
  flex-direction: row;
  flex: 1;
  min-height: 0;
`;

export const VolumeGridWrapper = styled("div")`
  display: flex;
  flex-direction: column;
`;

export const VolumeGridRow = styled("div")`
  display: flex;
  flex-direction: row;
`;

export const TableWrapper = styled("div")`
  display: flex;
  flex-direction: column;
  flex: 1;
  border-top: 1px solid #e0e0e0;
  border-left: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
  &:last-child {
    border-bottom: none;
  }
`;

export const TableRow = styled("div")`
  display: flex;
  flex-direction: row;
  flex: 1;
  border-bottom: 1px solid #e0e0e0;
  & .headercell {
    background-color: #e0e0e0;
    color: black;
    font-weight: bold;
  }
`;

export const TableCell = styled("div")`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  padding: 0.5em;
  text-align: center;
  border-right: 1px solid #e0e0e0;
  &:last-of-type: {
    borde: none;
  }
`;

export const SplitPanelContainer = styled("div")`
  display: flex;
  flex-direction: row;
  flex: 1;
  gap: 1em;
`;

export const SplitPanel = styled("div")`
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  flex: 1;
  padding: 1em;
  justify-content: center;
  background-color: #fafafa;
`;

export const OverCapacityItemContainer = styled("div")`
  display: flex;
  flex-direction: row;
  border-radius: 10px;
`;

export const YearIndicator = styled("div")`
  &&& {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2px 5px;
    border-radius: 3px;
    color: #fff;
    margin: 2px 0px 2px 4px;
    text-transform: capitalize;
    ${color}
    width: fit-content;
    height: fit-content;
  }
`;

export const PeakInboundItem = styled(`div`)`
  display: flex;
  border-radius: 10px;
  flex-direction: row;
  height: 5em;
  margin-bottom: 1em;
`;

export const PeakInboundDate = styled("div")`
  flex: 0.8;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.8em;
  background-color: #eeeeee;
  font-weight: bold;
`;
export const PeakInboundFigure = styled("div")`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-size: 0.9em;
  background-color: white;
`;
export const FigureLabel = styled("div")`
  display: block;
  text-align: center;
  font-weight: bold;
`;
export const FigureNumbers = styled("div")``;
